module.exports = {
	"parenting": [
		{
			"toolstitle": "Parenting Tool",
			"class": "parenting_tools",
			"subclass": "parenting_tools_container",
			"submenu": [
				{
					"id": "vaccine",
					"class": "vaccine_tools images",
					"href": "/tools/child-vaccination-growth-tracker",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/vaccination_tracker.jpg",
					"title": "Vaccination Tracker",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/vaccination1.svg"
				},
				{
					"id": "growth",
					"class": "growth_tools images",
					"href": "/tools/child-vaccination-growth-tracker?ref=growthtracker",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/growth_tracker.jpg",
					"title": "Growth Tracker",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/growthtracker.svg"
				},
				{
					"id": "diet_plan",
					"class": "baby_diet_tools images",
					"href": "/tools/baby-kids-diet-plan/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/diet_plan.jpg",
					"title": "Diet Plan (6 Months+)",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/dietplan.svg"
				},
				{
					"id": "breastfeeding",
					"class": "breastfeeding_tools images",
					"href": "/tools/breastfeeding-tracker/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/breast_feeding.jpg",
					"title": "Breastfeeding",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/breastfeeding.svg"
				},
				{
					"id": "memories",
					"class": "memories images",
					"href": "/memories/",
					"url": "https://cdn.firstcry.com/brainbees/apps/image/memories.jpg",
					"title": "Memories",
					"iconurl": "https://cdn.firstcry.com/brainbees/apps/image/memories-WT.svg"
				},
				{
					"id": "milestone",
					"class": "milestone images",
					"href": "/memories/milestones",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/milestone.jpg",
					"title": "Milestone",
					"iconurl": "https://cdn.firstcry.com/brainbees/apps/image/milestones-WT.svg"
				},
				{
					"id": "faceaday",
					"class": "faceAday images",
					"href": "/tools/capture-baby-moments/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/app_tools_face_day_background.jpg",
					"title": "Face A day",
					"iconurl": "//cdn.fcglcdn.com/brainbees/apps/image/app_tools_face_day_icon.svg"
				},
				{
					"id": "teething",
					"class": "babyteething images",
					"href": "/tools/baby-teething/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/app_tool_teething_background.jpg",
					"title": "Baby Teething",
					"iconurl": "//cdn.fcglcdn.com/brainbees/apps/image/app_tool_teething_icon.svg"
				},
				{
					"id": "growthndevp",
					"class": "growthndevp images",
					"href": "/tools/baby-growth-and-development/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/app_tool_gowth_development_background.jpg",
					"title": "Baby Growth & Development",
					"iconurl": "//cdn.fcglcdn.com/brainbees/apps/image/app_tools_growth_development_icon.svg"
				}
			]
		}
	],
	"pragnency": [
		{
			"toolstitle": "Pregnancy Tools",
			"class": "pregnancy_tools",
			"subclass": "pregnancy_tools_container fl",
			"submenu": [
				{
					"id": "fetus_movement_tracker",
					"class": "fetus_tools images",
					"href": "/tools/fetal-movement-tracker/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/fetus_movement_tracker.jpg",
					"title": "Fetus Movement Tracker",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/fetus.svg"
				},
				{
					"id": "baby_names",
					"class": "baby_names_tools images",
					"href": "/baby-names",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/baby_names.jpg",
					"title": "Baby Names",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/baby_name.svg"
				},
				{
					"id": "due_date_calculator",
					"class": "bduedate_tools images",
					"href": "/tools/pregnancy-due-date-calculator/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/due_date_calculator_logoimage.jpg",
					"title": "Due Date Calculator",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/date_calculator.svg"
				},
				{
					"id": "diet_plan_mom",
					"class": "mom_diet_tools images",
					"href": "/tools/pregnancy-diet-plan/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/moms_diet_plan.jpg",
					"title": "Diet Plan (Expecting Mom's)",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/moms_diet_plan.svg"
				},
				{
					"id": "pregnancy_inspection",
					"class": "pregnancy_inspection images",
					"href": "/tools/pregnancy-checkup-schedule/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/pregancy_inspection.jpg",
					"title": "Pregnancy Inspection Schedule",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/pregnancy_inspection_icon_tools.svg"
				},
				{
					"id": "my_bumpie",
					"class": "my_bumpie images",
					"href": "/tools/my-baby-bump/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/my_bumpie_tools_background.jpg",
					"title": "My Bumpie",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/my_bumpie_tools_icon.svg"
				},
				{
					"id": "weekByweek",
					"class": "weekByweek images",
					"href": "/tools/pregnancy-week-by-week-tracker/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/app_tools_week_byweek_fetal_background.jpg",
					"title": "Week by Week Fetal Developments",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/app_tools_weekbyweek_icon.svg"
				},
				{
					"id": "babysizecomparison",
					"class": "babysizecomparison images",
					"href": "/tools/baby-size-comparison/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/app_tools_baby_sizecomp_background.jpg",
					"title": "Baby Size Comparison",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/app_tools_baby_size_com_icon.svg"
				},
				{
					"id": "fetaldevelopmentvideo",
					"class": "fetusvideo images",
					"href": "/tools/fetal-development-video/",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/app_tool_fetal_development_video_background.jpg",
					"title": "Fetal Development Video",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/app_tool_fetal-develpment_videos_icon.svg"
				}
			]
		}
	],
	"other": [
		{
			"toolstitle": "Other Tools",
			"class": "other_tools",
			"subclass": "other_tools_container",
			"submenu": [
				{
					"id": "period_ovulation_calculator",
					"class": "period_ovulation images",
					"href": "/tools/period-ovulation-calculator",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/period_calculator.jpg",
					"title": "Period & Ovulation Calculator",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/period_ovulation.svg"
				},
				{
					"id": "groups",
					"class": "groups images",
					"href": "/groups",
					"url": "https://cdn.fcglcdn.com/brainbees/apps/image/group.jpg",
					"title": "Groups",
					"iconurl": "https://cdn.fcglcdn.com/brainbees/apps/image/group-icon-WT.svg"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/tools/Tools.json
// module id = 222
// module chunks = 0